import "./App.css";
import React, { useEffect } from "react";
import axios from "axios";
import ReactGA from "react-ga4";
import CookieConsent from "react-cookie-consent";
import Hero from "./components/Hero";
import { ContactForm } from "./components/ContactForm";
import Header from "./components/Header";
import AboutTimeline from "./components/AboutTimeline";
import Services from "./components/Services";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
    ReactGA.send("pageview");
  }, []);

  return (
    <Router>
      <Header />

      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/about" element={<AboutTimeline />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/services" element={<Services />} />
      </Routes>

      <CookieConsent>
        This website uses cookies to enhance the user experience.
      </CookieConsent>
    </Router>
  );
}

export default App;
